import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import { NavBar } from "../Navbar/NavBar";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import PendingForCollectionByBatch from "./pendingForCollectionByBatchPage";
import PendingForCollectionByOrder from "./pendingForCollectionByOrderPage";
import CollectedByBatchPage from "./collectedByBatchPage";
import CollectedByOrderPage from "./collectedByOrderPage";
import Sidebar from "../Sidebar";
import "../../Assets/CSS/bulkorder.css";
function PlatformCharges() {
  const [activeTab, setActiveTab] = useState("pendingForCollection");
  const [selectById, setSelectById] = useState("batch");

  return (
    <div className="flex">
      <div className="container-fluid mt-3 ml-8 builk-main  p-2">
        <div className="row mx-0">
          <div className="col-12 text-start mb-3">
            <h4 style={{ color: "#0C3094" }}>Platform Charges</h4>
          </div>

          <div className="mb-3">
            <button
              role="tab"
              className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                activeTab === "pendingForCollection"
                  ? "text-white bg-dark shadow-sm"
                  : "text-gray-500 dark:text-gray-300"
              } mr-3`}
              onClick={() => setActiveTab("pendingForCollection")}
            >
              Pending For Collection
            </button>
            <button
              role="tab"
              className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                activeTab === "collected"
                  ? "text-white bg-dark shadow-sm"
                  : "text-gray-500 dark:text-gray-300"
              }`}
              onClick={() => setActiveTab("collected")}
            >
              Collected
            </button>
          </div>

          <div className="flex mb-3">
            <button
              role="tab"
              className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                selectById === "batch"
                  ? "text-white bg-dark shadow-sm"
                  : "text-gray-500 dark:text-gray-300"
              } mr-3`}
              onClick={() => setSelectById("batch")}
            >
              By Batch ID
            </button>

            <button
              role="tab"
              className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                selectById === "order"
                  ? "text-white bg-dark shadow-sm"
                  : "text-gray-500 dark:text-gray-300"
              } mr-3`}
              onClick={() => setSelectById("order")}
            >
              By Order ID
            </button>
          </div>
        </div>
        {activeTab === "pendingForCollection" ? (
          selectById === "batch" ? (
            <PendingForCollectionByBatch />
          ) : (
            <PendingForCollectionByOrder />
          )
        ) : null}

        {activeTab === "collected" ? (
          selectById === "batch" ? (
            <CollectedByBatchPage />
          ) : (
            <CollectedByOrderPage />
          )
        ) : null}
      </div>
    </div>
  );
}

export default PlatformCharges;
